import type { Module } from 'vuex'
import type { RootState, ClientConfigState } from '../types'
import type { ClientConfig } from '@/config/types'
import { placeholderClientConfig } from '@/config/defaults'

/**
 * Holds the active client config. All per-client derivations (logo, ad image,
 * favicon, AccuWeather discrimination…) live in the typed `clientConfig` accessor
 * in `@/store`, which reads this state directly — so there are no string-keyed
 * Vuex getters to consume.
 */
const clientConfigModule: Module<ClientConfigState, RootState> = {
  namespaced: true,
  state: (): ClientConfigState => ({
    // The real client config is hydrated at boot from main.ts via dynamic import,
    // committed through `updateConfig` before the app mounts. The placeholder keeps
    // the store typed and safe to read during the brief window before hydration.
    config: placeholderClientConfig,
  }),
  mutations: {
    /**
     * Replaces the active config — called by main.ts after the per-client config
     * module finishes loading, and again after `applyRuntimeConfig()` merges the
     * optional CDN overlay. By the time the app mounts, this has settled.
     */
    updateConfig(state, config: ClientConfig) {
      state.config = config
    },
  },
}

export default clientConfigModule
